/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input-serializer for the Automated Quote Generation feature.
 * Note: do not use this serializer for output-serialization.
 * @export
 * @interface APIAQGUploadRequest
 */
export interface APIAQGUploadRequest {
    /**
     * 
     * @type {Blob}
     * @memberof APIAQGUploadRequest
     */
    document: Blob;
    /**
     * 
     * @type {string}
     * @memberof APIAQGUploadRequest
     */
    quantity: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIAQGUploadRequest
     */
    acceptPrivacyPolicy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIAQGUploadRequest
     */
    isGeneratedModel?: boolean;
}

/**
 * Check if a given object implements the APIAQGUploadRequest interface.
 */
export function instanceOfAPIAQGUploadRequest(value: object): value is APIAQGUploadRequest {
    if (!('document' in value) || value['document'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('acceptPrivacyPolicy' in value) || value['acceptPrivacyPolicy'] === undefined) return false;
    return true;
}

export function APIAQGUploadRequestFromJSON(json: any): APIAQGUploadRequest {
    return APIAQGUploadRequestFromJSONTyped(json, false);
}

export function APIAQGUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAQGUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'document': json['document'],
        'quantity': json['quantity'],
        'acceptPrivacyPolicy': json['accept_privacy_policy'],
        'isGeneratedModel': json['is_generated_model'] == null ? undefined : json['is_generated_model'],
    };
}

export function APIAQGUploadRequestToJSON(value?: APIAQGUploadRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'document': value['document'],
        'quantity': value['quantity'],
        'accept_privacy_policy': value['acceptPrivacyPolicy'],
        'is_generated_model': value['isGeneratedModel'],
    };
}

